import * as React from "react";

function SvgMessage(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={17.03}
      height={14.623}
      {...props}
    >
      <path
        d="M15.663 0H1.367A1.369 1.369 0 000 1.368v11.887a1.369 1.369 0 001.367 1.368h14.3a1.369 1.369 0 001.363-1.368V1.368A1.369 1.369 0 0015.663 0zM8.556 5.89a.679.679 0 01-.49-.207l-.027-.027-5.2-4.288H14.2L9.108 5.623l-.031.025-.026.029a.681.681 0 01-.492.213zm-7.189 7.365V1.923l5.748 4.74a2.038 2.038 0 001.443.594h.01a2.031 2.031 0 001.447-.606l5.65-4.728v11.332z"
        fill="#3c4252"
      />
    </svg>
  );
}

export default SvgMessage;
